module.exports = __webpack_public_path__ + "static/images/styles/images/table/table-row-expandable-own.c9d5858d.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/table/table-row-expandable-own.png
// module id = 3840
// module chunks = 11